import { render, staticRenderFns } from "./newOwnerContract.vue?vue&type=template&id=797b7b44&scoped=true&"
import script from "./newOwnerContract.vue?vue&type=script&lang=js&"
export * from "./newOwnerContract.vue?vue&type=script&lang=js&"
import style0 from "./newOwnerContract.vue?vue&type=style&index=0&id=797b7b44&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797b7b44",
  null
  
)

export default component.exports